module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/limit-flow-proposal/component/actions/request-pending-approval/request-pending-approval.component.scss
// module id = ./src/app/limit-flow-proposal/component/actions/request-pending-approval/request-pending-approval.component.scss
// module chunks = main